// Every sentence the Supporter page and the admin page show (docs/SUPPORTERS.md 19).
// Calm and plain. No em dashes, no timers, no "only N left", no guilt on the way out.
// test/supporters.copy.test.mjs reads this file.

export const T = {
	title: "Support Re:Vault",
	intro: "Re:Vault is free for studying, and it stays that way. A pass adds looks, a Study Hall badge and a few other extras, and it pays for the servers so Re:Vault never needs ads from strangers.",
	freeNote: "Everything you need to study stays free for everyone: tabs, bookmarks, Books, Tools, Linux, Study Hall, cloud backup, accessibility and privacy settings.",
	oneTime: "This is a one-time payment. Nothing renews.",
	refundLine: "Changed your mind? Ask within 7 days for a full refund, no questions asked.",
	parentLine: "If you're under 18, check with a parent first.",
	scam: "Re:Vault staff will never ask you to pay anyone except the handle on this page, and never ask for passwords or codes.",
	closed: "Supporter passes open soon.",
	down: "Supporters are taking a short break. Everything else works as usual.",
	signedOut: "Sign in to get a pass, redeem a code or link Discord. Reading this page is fine without an account.",
	signIn: "Sign in to continue",
	pick: "Pick a pass",
	pickHelp: "Each pass is paid once. When it ends, it simply stops. Nothing you made is deleted.",
	asGift: "Buy this as a gift",
	giftHelp: "You get a code to give to someone. It works for 12 months.",
	showName: "Show my Study Hall name to the person who gets it",
	continue: "Continue",
	back: "Back",
	review: "Check your order",
	youGet: "What you get",
	price: "Price",
	endsToday: (d) => "If it's paid today, your pass runs until " + d + ".",
	startsAfter: "If you already have a pass, the new time starts when the current one ends.",
	lifetime: "Lifetime means for as long as Re:Vault runs.",
	getCode: "Get my order code",
	working: "One moment",
	orderTitle: "Your order",
	codeLabel: "Order code",
	copy: "Copy",
	copied: "Copied",
	copyFail: "Couldn't copy. Select the code and copy it yourself.",
	amount: "Amount",
	howToPay: "How to pay",
	payBy: (d) => "Pay by " + d + ". After that this order expires. If you paid and pressed \"I've sent it\" before then, it still counts.",
	stepsCash: (amount, handle, code) => ["Open Cash App.", "Pay " + amount + " to " + handle + ".", "Paste " + code + " in the note (the \"For\" box).", "Send it, then come back here."],
	stepsApple: (amount, handle, code) => ["Open Messages and start a message to " + handle + ".", "Tap the Apple Cash button and send " + amount + ".", "Send " + code + " as a message right after, so we can match it.", "Come back here."],
	openCash: "Open Cash App",
	payee: (n) => "The payment shows up as " + n + ".",
	sentBtn: "I've sent it",
	sentHelp: "Optional. It tells staff to look for your payment. It doesn't change anything else.",
	sentDone: "Thanks. Staff will look for your payment. This page updates on its own.",
	waiting: "Waiting for staff to confirm the payment. This usually takes less than a day.",
	cancelBtn: "Cancel this order",
	cancelHelp: "If you already paid, don't cancel: contact us and we'll sort it out.",
	cancelled: "This order was cancelled.",
	expired: "This order expired without a payment. Make a new one any time.",
	expiredSent: "This order passed its pay-by time before staff confirmed it. You said you sent it, so staff can still confirm it. If nothing changes in a few days, contact us with the order code.",
	revoked: "The pass from this order was removed. Contact us if you think that's a mistake.",
	paid: "Your pass is on. Thank you for supporting Re:Vault.",
	paidGift: "Your gift codes are ready. Thank you for supporting Re:Vault.",
	refunded: "This order was refunded.",
	disputed: "This payment was disputed, so the pass from it was removed.",
	receipt: "Receipt",
	receiptHelp: "Anyone with this link can read the receipt, so you can send it to a parent.",
	newReceipt: "Get a new receipt link",
	refundAsk: "Ask for a refund",
	refundAsked: "We got your refund request. Staff will send the money back and let you know.",
	giftCodes: "Gift codes",
	giftCodesHelp: "Give each code to one person. They enter it on this page under Redeem a code. Unused codes expire after 12 months.",
	redeemedOn: (d) => "Redeemed on " + d,
	notRedeemed: "Not used yet",
	voided: "Turned off",
	myOrders: "Your orders",
	noOrders: "No orders yet.",
	open: "Open",
	redeemTitle: "Redeem a code",
	redeemHelp: "Got a gift code? Type or paste it here.",
	redeemLabel: "Gift code",
	redeemBtn: "Redeem",
	redeemed: (what, from) => what + " added" + (from ? ", a gift from " + from : ", a gift from a friend") + ".",
	linkTitle: "Link Discord",
	linkHelp: "In the Re:Vault Discord server, type /supporter link. Ep3 replies with a code that works for 10 minutes. Enter it here.",
	linkFree: "If you support Re:Vault on Discord (Server Booster, subscriber or Donor), linking gives you a free Semester Pass.",
	linkLabel: "Link code",
	linkBtn: "Link",
	linked: "Discord is linked.",
	linkedClaimed: "Discord is linked, and your free Semester Pass is on. Thank you for supporting us on Discord.",
	unlinkBtn: "Unlink Discord",
	unlinked: "Discord is unlinked.",
	perksTitle: "Your perk choices",
	perksHelp: "These only show while your pass is on. Everything is off until you turn it on.",
	showBadge: "Show in Study Hall",
	showBadgeHelp: "A small Supporter badge next to your name, with the name color and flair below.",
	nameColor: "Name color",
	noColor: "Default",
	flair: "Flair",
	noFlair: "None",
	credits: "Show my Study Hall name in the credits on the About page",
	remind: "Remind me before my pass ends",
	remindHelp: "One quiet card on the start page 3 days before. Never in a tab or during a focus timer.",
	saved: "Saved.",
	adds: "What a pass adds",
	addsList: [
		"New looks 30 days early, and Supporter looks you can try on for a minute first",
		"Save up to 10 wallpapers and switch between them",
		"A Study Hall badge, name color and flair, if you want them",
		"Named tab sessions and 30 days of cloud restore points",
		"Try new features early and vote on what gets made next",
		"No ad cards at all",
	],
	patronAdds: "Patron adds a Patron badge, an optional name in the credits and a vote on the next look. One account, one vote.",
	meter: (cost, pct) => "Re:Vault costs about " + cost + " a month to run. This month supporters covered " + pct + "%.",
	meterHow: "Each pass is spread over the months it covers. Refunds are taken back out.",
	started: (n) => n + (n === 1 ? " pass" : " passes") + " started since October 2026.",
	data: "Download my supporter data",
	privacy: "How supporter passes handle your data",
	bestValue: "Best value",
	save: (pct) => "Save " + pct + "% vs Month",
	perMonth: (p) => "About " + p + " a month",
	foundingEnds: "Ends November 30, 2026 at 11:59 PM Eastern",
	// The owner can end the offer earlier in config, never later; the page then shows the real date.
	foundingEndsAt: (t) => {
		const o = {};
		for (const x of new Intl.DateTimeFormat("en-US", { month: "long", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit", timeZone: "America/New_York" }).formatToParts(new Date(t))) o[x.type] = x.value;
		return "Ends " + o.month + " " + o.day + ", " + o.year + " at " + o.hour + ":" + o.minute + " " + o.dayPeriod + " Eastern";
	},
	giftOnly: "Three Semester Pass gift codes for a study group. You can keep one.",
	sale: (label, d) => label + ". Ends " + d + ".",
	err: "Something went wrong. Try again in a minute.",
	status: "Your pass",
};

export const ADMIN = {
	title: "Supporter orders",
	closed: "Checkout is closed: fill in supporters-config.json (payment handles, payee name, contact) and set enabled to true.",
	closedSecrets: "Checkout is closed: SUPPORTERS_CODE_PEPPER isn't set.",
	closedApple: "Checkout is closed: the Apple Cash handle has to be an email address, never a phone number.",
	open: "Checkout is open.",
	noBot: "SUPPORTERS_BOT_TOKEN isn't set, so Ep3 can't confirm orders yet.",
	noTotp: "No authenticator is set up for you. Money actions need one (SUPPORTERS_ADMIN_TOTP).",
	queue: "Waiting for payment",
	queueEmpty: "Nothing waiting.",
	refunds: "Refund requests",
	refundsEmpty: "No refund requests.",
	lookup: "Look up an order, gift code ending or Study Hall name",
	lookupBtn: "Look up",
	stats: "Totals",
	confirm: "Confirm payment",
	confirmCheck: (code, price) => "Check the payment app: the note says " + code + " and the amount is " + price + ". Never confirm from a screenshot or a message.",
	received: "Amount received (dollars)",
	method: "Method",
	totp: "Authenticator code",
	reason: "Reason",
	refund: "Refund",
	dispute: "Mark disputed",
	reinstate: "Reinstate",
	revoke: "Revoke (fraud only)",
	reopen: "Re-open as new order",
	void: "Turn off code",
	comp: "Make a free gift code",
	override: "Amount differs: owner override with a reason",
	done: "Done.",
};
